import React from "react";
import PropTypes from "prop-types";
import "./style.scss";

export default function SwiperModalTitle({ count, gameFormat }) {
  SwiperModalTitle.propTypes = {
    count: PropTypes.string,
    gameFormat: PropTypes.oneOf(["marathon", "compromise", ""]),
  };
  return (
    <div className="swiper-modal-title">
      <span className="swiper-modal-title__count">{count}</span>
      {/*{gameFormat === config.gameFormats.marathon && (
        <span className="swiper-modal-title__question">
          {text.modals.swiper_modal.marathon_title}
        </span>
      )}*/}
    </div>
  );
}
